module.exports = __webpack_public_path__ + "img/draft.b2d98dba.svg";